import qs from '@halobear/utils/qs'
import localData from '@halobear/utils/localData'

const TWENTY_HOURS = 60 * 20

const key = process.env.VUE_APP_AUTH || 'vue-boilerplate'

const authority = localData.create(key, TWENTY_HOURS)

// 默认从url获取参数
const token = qs.get('token')
if (token) {
  window.tmpAppToken = token
}
function getToken() {
  return window.tmpAppToken || (authority.get() || {}).token || ''
}

export {
  getToken
}

export default authority
